import { Link, useParams } from "react-router-dom";
import { FaqPanel } from "../components/FaqPanel";
import { TopBar } from "../components/TopBar";

export function FaqPage() {
  const { slug = "" } = useParams();
  return (
    <div className="app-shell">
      <TopBar>
        <Link to={`/courses/${slug}`} className="btn btn-sm btn-ghost">
          ← Back to course
        </Link>
      </TopBar>
      <main className="faq-page-wrap">
        <FaqPanel slug={slug} refreshKey={0} fullPage />
      </main>
    </div>
  );
}
